var _defs, _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconShow = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0);}.b{fill:#8798ad;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-369 -344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36,0H68V32H36Z",
    transform: "translate(333 344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43,20.8a14.256,14.256,0,0,0,18,0h0q.345-.272.658-.547A17.582,17.582,0,0,0,64.045,17.7c.266-.349.467-.643.6-.852.068-.1.121-.189.157-.249a1.05,1.05,0,0,0,.061-1.1l-.023-.039-.054-.089c-.046-.075-.112-.18-.2-.311-.174-.261-.431-.625-.77-1.052A17.512,17.512,0,0,0,61,11.2h0a14.256,14.256,0,0,0-18,0h0q-.345.272-.659.548A17.589,17.589,0,0,0,39.954,14.3c-.266.349-.467.643-.6.852-.068.1-.121.189-.157.248l-.043.071-.012.021,0,.007v0h0a1,1,0,0,0,0,.993h0l0,0,.007.012.023.04c.02.033.048.079.085.138.073.116.179.28.32.481a16.758,16.758,0,0,0,1.247,1.57A17.391,17.391,0,0,0,43,20.8Zm0-2.664h0c.2.2.424.406.659.611a12.322,12.322,0,0,0,16.683,0c.234-.2.454-.41.659-.611h0a15.56,15.56,0,0,0,1.454-1.648c.14-.184.258-.348.355-.488-.139-.2-.323-.453-.551-.74A15.643,15.643,0,0,0,61,13.864h0c-.2-.2-.424-.406-.659-.611a12.322,12.322,0,0,0-16.683,0c-.234.2-.454.41-.659.611h0a15.554,15.554,0,0,0-1.455,1.649c-.14.184-.258.348-.355.488l.021.03a14.776,14.776,0,0,0,1.1,1.381C42.517,17.645,42.748,17.888,43,18.136ZM52,18a2,2,0,1,0-2-2A2,2,0,0,0,52,18Zm0,2a4,4,0,1,0-4-4A4,4,0,0,0,52,20Z",
    transform: "translate(333 344)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconShow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-show.371ecdc1.svg";
export { ForwardRef as ReactComponent };